import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_bibo_reposition",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header flex-stack" }
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body scroll-y pt-10 pb-15 px-lg-17" }
const _hoisted_8 = { class: "card-body py-3" }
const _hoisted_9 = { class: "row mb-5" }
const _hoisted_10 = { class: "col-md-12 fv-row py-1" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Please enter the ")
const _hoisted_12 = /*#__PURE__*/_createVNode("mark", null, "upline ID", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" and the ")
const _hoisted_14 = /*#__PURE__*/_createVNode("mark", null, "position", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" you want to put ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" under. ")
const _hoisted_17 = { class: "row mb-5" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-1" }, null, -1)
const _hoisted_19 = { class: "col-md-6 fv-row py-1" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-1" }, null, -1)
const _hoisted_21 = { class: "row mb-5" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-1" }, null, -1)
const _hoisted_23 = { class: "col-md-6 fv-row py-1" }
const _hoisted_24 = /*#__PURE__*/_createVNode("option", { value: "XXX" }, "Select Position", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("option", { value: "L" }, "Left", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("option", { value: "R" }, "Right", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-1" }, null, -1)
const _hoisted_28 = { class: "row mb-5 text-center" }
const _hoisted_29 = { for: "checkboxCHEQUE" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" I want to proceed.")
const _hoisted_31 = { class: "row mb-5" }
const _hoisted_32 = { class: "col-md-12 fv-row py-1 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("h2", null, "Reposition this User ID: " + _toDisplayString(_ctx.usid), 1),
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
            ])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("p", null, [
                  _hoisted_11,
                  _hoisted_12,
                  _hoisted_13,
                  _hoisted_14,
                  _hoisted_15,
                  _createVNode("mark", null, _toDisplayString(_ctx.usid), 1),
                  _hoisted_16
                ])
              ])
            ]),
            _createVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode("div", _hoisted_19, [
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                  placeholder: "Upline ID",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.upid_input = $event))
                }, null, 512), [
                  [_vModelText, _ctx.upid_input]
                ])
              ]),
              _hoisted_20
            ]),
            _createVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode("div", _hoisted_23, [
                _withDirectives(_createVNode("select", {
                  class: "form-select form-select-solid",
                  id: "position",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.position_selected = $event))
                }, [
                  _hoisted_24,
                  _hoisted_25,
                  _hoisted_26
                ], 512), [
                  [_vModelSelect, _ctx.position_selected]
                ])
              ]),
              _hoisted_27
            ]),
            _createVNode("div", _hoisted_28, [
              _createVNode("label", _hoisted_29, [
                _createVNode("input", {
                  type: "checkbox",
                  id: "checkboxCHEQUE",
                  value: "",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.checkBoxValidator($event);})
                }),
                _hoisted_30
              ])
            ]),
            _createVNode("div", _hoisted_31, [
              _createVNode("div", _hoisted_32, [
                (_ctx.isShowProceedBtn)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      class: "btn btn-sm btn-info min-w-100px",
                      "data-bs-toggle": "modal",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.process_repositioning();})
                    }, " Proceed "))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}